import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "visible"];
import { useEffect, memo } from 'react';
import { useStore } from "./store.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var Button = /*#__PURE__*/memo(props => {
  var {
    buttons = {},
    dispatch
  } = useStore();
  useEffect(() => {
    var {
        keyname,
        visible = true
      } = props,
      elmProps = _objectWithoutPropertiesLoose(props, _excluded);
    if (keyname || elmProps.name) {
      var key = keyname || elmProps.name;
      delete buttons[key];
      dispatch({
        buttons: _extends({}, buttons, {
          [key]: visible ? /*#__PURE__*/_jsx("button", _extends({
            type: "submit"
          }, elmProps)) : null
        })
      });
    }
  }, [props]);
  return null;
});
Button.displayName = 'Login.Button';